import { Button } from "@workspace/web-ui/components/button";
import { cn } from "@workspace/web-ui/lib/utils";
import { PlusIcon } from "lucide-react";
import { useState } from "react";
import { Tasks } from "~/features/dashboard/components/tasks";
import TaskContainer from "~/features/dashboard/components/tasks/task-container";

type RecommendedTaskProps = {
    encounterId: string
    className?: string
    patientId: string
    showAddButton?: boolean
}

export function RecommendedTask({ encounterId, patientId, className, showAddButton = true }: RecommendedTaskProps) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={cn("flex, flex-col space-y-2 my-2", className)}>
            <div className="w-full flex justify-between gap-4 items-center">
                {showAddButton && (
                    <>
                    <h2 className="text-xl font-medium">Recommended Task</h2>
                    <Button className="button-primary !bg-[#4272DD] !text-white !flex !gap-2 !border-none !shadow-none" onClick={() => setIsOpen(true)}>
                        <PlusIcon className="w-4 h-4 text-white" />
                        Add
                    </Button>
                    </>
                )}
            </div>
            {isOpen && (
                <Tasks open={isOpen} onOpenChange={setIsOpen} id={encounterId} className="bg-[#EFF0F2]" />
            )}
            <TaskContainer encounterId={encounterId} patientId={patientId} />
        </div>
    )
}

